<template>
   <h2>Account Deletion Policy</h2>
    <p>
        Users can request deletion of their Darcom Business account and associated data by emailing <a href="mailto:info@darcom.ps">info@darcom.ps</a>., or from profile in app. Upon receiving a deletion request, we will remove all user data from our servers within 90 days. Please note that some information may be retained for legal or administrative purposes. Uninstalling the app does not automatically delete your account or data. For more information on data handling.
    </p>

</template>